//@flow

import * as React from 'react';

import { injectScale } from './ScaleContext';
import OvenFrame from '../../../../assets/images/pages/pizza/fields/pizza_yaku02@3x.png';

type Props = {
  scale: number,
  children: React.Node,
};

const Fire = ({ className }: { className: string }) => {
  return (
    <svg className={`fire ${className}`} viewBox="0 0 50 50" preserveAspectRatio="xMinYMax meet">
      <g>
        <polygon points="0,25 25,0 50,25 25,50" />
      </g>
    </svg>
  );
};

class PizzaOven extends React.PureComponent<Props> {
  render() {
    const style = {
      height: this.props.scale * 474,
      width: this.props.scale * 864,
    };
    return (
      <div className="pizza-background pizza-oven" style={style}>
        <div className="fire-container">
          <Fire className="red" />
          <Fire className="yellow" />
          <Fire className="red" />
          <Fire className="yellow" />
          <Fire className="red" />
          <Fire className="yellow" />
          <Fire className="red" />
        </div>
        <img className="pizza-image pizza-oven-frame" src={OvenFrame} />
        {this.props.children}
      </div>
    );
  }
}

export default injectScale(PizzaOven);
